import { render, staticRenderFns } from "./scWpStreamingCountdownWidget.vue?vue&type=template&id=3eed21b6&scoped=true&"
import script from "./scWpStreamingCountdownWidget.vue?vue&type=script&lang=js&"
export * from "./scWpStreamingCountdownWidget.vue?vue&type=script&lang=js&"
import style0 from "./scWpStreamingCountdownWidget.vue?vue&type=style&index=0&id=3eed21b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eed21b6",
  null
  
)

export default component.exports